import { Modal } from 'antd'
import { Button } from 'components/Button'
import { Heading } from 'components/Typography'
import React from 'react'

const RequestsConfirmationModal = ({ open, onCancel, title, onYes }) => {
    return (
        <Modal
            centered
            closable={false}
            open={open}
            onCancel={onCancel}
            footer={null}
            className='modal-round-corner'
        >
            <center className='p-20'>
                <div>
                    <Heading>{title}</Heading>
                </div>
                <div className='r-jsb m-t-20' style={{ width: '60%' }}>
                    <Button onClick={onCancel} style={{ padding: '0 10px 0 10px',}}>No</Button>
                    <Button type='primary' onClick={onYes} style={{ padding: '0 10px 0 10px' }}>Yes</Button>
                </div>
            </center>
        </Modal>
    )
}

export default RequestsConfirmationModal